import {
  ConsolidatedForecastCreateData,
  ConsolidatedForecastUpdateData
} from '../../predict/src/core/api/types/consolidated-forecasting';
import { consolidatedForecastsQueryKey } from '../queries/consolidatedForecasts';
import {
  createConsolidatedForecast,
  deleteConsolidatedForecast,
  updateConsolidatedForecast
} from '../../predict/src/core/api/consolidated-forecasting';
import { createMutation } from '../utils/mutations';
import { queryClient } from '../core/queryClient';

type CreateConsolidatedForecastResult = Awaited<ReturnType<typeof createConsolidatedForecast>>;
type DeleteConsolidatedForecastResult = Awaited<ReturnType<typeof deleteConsolidatedForecast>>;
type UpdateConsolidatedForecastResult = Awaited<ReturnType<typeof updateConsolidatedForecast>>;

export const createConsolidatedForecastMutation = (workspaceId: string, consolidationId: string) => {
  return createMutation<ConsolidatedForecastCreateData, CreateConsolidatedForecastResult>({
    mutationFn: data => createConsolidatedForecast(workspaceId, consolidationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consolidatedForecastsQueryKey(consolidationId, workspaceId) });
    }
  });
};

export const deleteConsolidatedForecastMutation = (workspaceId: string, consolidationId: string) =>
  createMutation<string, DeleteConsolidatedForecastResult>({
    mutationFn: forecastId => deleteConsolidatedForecast(workspaceId, consolidationId, forecastId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consolidatedForecastsQueryKey(consolidationId, workspaceId) });
    }
  });

export const updateConsolidatedForecastMutation = (workspaceId: string, consolidationId: string) =>
  createMutation<{ forecastId: string; data: ConsolidatedForecastUpdateData }, UpdateConsolidatedForecastResult>({
    mutationFn: input => updateConsolidatedForecast(workspaceId, consolidationId, input.forecastId, input.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consolidatedForecastsQueryKey(consolidationId, workspaceId) });
    }
  });
